// frontend/src/components/Modals/QuoteConfirmModal.jsx
// ✅ VERSIÓN COMPLETA CON TODOS LOS CAMPOS

import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Alert, Badge, Button, Row, Col } from 'reactstrap';
import ClientMatchSelector from './ClientMatchSelector';
import { sellersAPI } from '../../services/api';

const QuoteConfirmModal = ({ isOpen, toggle, data, clientMatch, versionInfo, sellerMatch, onConfirm }) => {
  const [loading, setLoading] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [availableSellers, setAvailableSellers] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [dataPreFilled, setDataPreFilled] = useState(false); 
  const [formData, setFormData] = useState({
    proposal_number: '',
    quote_date: '',
    category: '',
    service_type: '',
    account_manager: '',
    contact_name: '',
    contact_email: '',
    contact_phone: '', 
    rfc: '',                    // ✅ AGREGAR ESTA LÍNEA
    direccion: '',  
    subtotal: '',
    notes: '',
    client_name: '',
    client_razon_social: '',
    num_personas: '',
    num_grupos: '',
    horas_totales: '',
    num_sesiones: '',
    nivel: '',
    idioma: '',
    ubicacion: '',
    incluye: '',
    material_type: '',
    viaticos: false,
    viaticos_cobrado: '',  
    lugar: '',
    lugar_cobrado: '',  
    costo_viaticos: '',
    costo_lugar: '',
    material_cobrado: '',      // ✅ NUEVO
    material_costo: '',         // ✅ NUEVO
    otros_cobrado: '', 
    material_didactico: '',
    otros_costos: '',
    precio_hora: '',
    terminos_pago: '',
    credit_days: '', 
  });

  // ✅ 1. Cargar vendedores disponibles
  useEffect(() => {
    console.log('🔄 useEffect VENDEDORES ejecutándose - isOpen:', isOpen);
    if (isOpen) {
      loadSellers();
    }
  }, [isOpen]);

  const loadSellers = async () => {
    try {
      const response = await sellersAPI.getAll();
      console.log('🔍 Vendedores cargados:', response.data);
      setAvailableSellers(response.data.sellers || []);
    } catch (error) {
      console.error('Error cargando vendedores:', error);
    }
  };

  // ✅ 2. Generar URL del PDF (CORREGIDO - Usar endpoint de descarga)
  useEffect(() => {
    console.log('🔄 useEffect PDF URL ejecutándose - data:', !!data);
    const pdfPath = data?.temp_files?.pdf_last_page_path || data?.temp_files?.pdf_path;
    
    if (pdfPath) {
      const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
      
      // Extraer solo el nombre del archivo
      let filename = pdfPath.replace(/\\/g, '/').split('/').pop();
      
      // Construir URL usando el endpoint de descarga
      const url = `${baseURL}/api/quotes/serve-temp-pdf/?file=${encodeURIComponent(filename)}`;
      
      console.log('📄 PDF URL:', url);
      setPdfUrl(url);
    } else {
      setPdfUrl(null);
    }
  }, [data?.temp_files?.pdf_last_page_path, data?.temp_files?.pdf_path]);



  // ✅ 3. Pre-llenar datos desde PDF (SOLO UNA VEZ)
  useEffect(() => {
    console.log('🔄 useEffect PRE-LLENADO ejecutándose - data:', !!data, 'dataPreFilled:', dataPreFilled);
    
    // ✅ IMPORTANTE: Solo ejecutar si hay datos Y no se han pre-llenado antes
    if (data && !dataPreFilled) {
      console.log('✅ PRE-LLENANDO DATOS...');

      console.log('🔍 DATA COMPLETA RECIBIDA:', data);
      
      const serviceDetails = data.service_details || {};
      const logistics = data.logistics || {};
      const costs = data.costs || {};
      const payment = data.payment || {};
      const clientInfo = data.client_info || {};

      const mappedData = {
        // Información básica
        proposal_number: data.proposal_number || '',
        quote_date: data.quote_date || '',
        
        // Cliente
        client_name: clientInfo.client_name || '',
        client_razon_social: clientInfo.legal_name || '',
        account_manager: data.account_manager || clientInfo.account_manager || '',
        contact_name: clientInfo.contact_name || data.contact_name || '',
        contact_email: clientInfo.contact_email || data.contact_email || '',
        contact_phone: clientInfo.contact_phone || data.contact_phone || '',
        rfc: '',
        direccion: '',
        
        // Servicio
        category: serviceDetails.category || data.category || '',
        service_type: serviceDetails.service_type || data.service_type || '',
        num_personas: String(serviceDetails.num_people || ''),
        num_grupos: String(serviceDetails.num_groups || ''),
        horas_totales: String(serviceDetails.num_hours || ''),
        num_sesiones: String(serviceDetails.num_sessions || ''),
        nivel: serviceDetails.administrative_level || '',
        idioma: serviceDetails.language || '',
        ubicacion: serviceDetails.city_state || '',
        incluye: serviceDetails.includes || '',
        
        precio_hora: serviceDetails.price_per_hour || '',
        material_type: serviceDetails.material_type || data.material_type || '',
        
        // Logística
        viaticos: logistics.viaticos === true || logistics.viaticos_charged === true,
        viaticos_cobrado: logistics.viaticos_charged || '', 
        lugar: logistics.lugar === true ? 'SI' : 'NO',
        costo_viaticos: logistics.viaticos_charged || '',
        costo_lugar: logistics.lugar_cost || '',
        lugar_cobrado: logistics.lugar_charged || '',   
        
        // Costos
        material_cobrado: serviceDetails.material_charged || costs.material_charged || '',
        material_didactico: costs.material_cost || '',
        otros_costos: costs.other_costs || '',
        otros_cobrado: costs.other_charged || '',
        
        // Pago
        subtotal: payment.subtotal || data.subtotal || '',
        terminos_pago: payment.payment_terms || '',
        credit_days: payment.credit_days || data.credit_days || '', 
        notes: '',
      };

      console.log('📋 Datos mapeados:', mappedData);
      setFormData(mappedData);
      
      // ✅ MARCAR COMO PRE-LLENADO
      setDataPreFilled(true);
    }
  }, [data]); // ✅ SOLO data como dependencia


  // ✅ NUEVO: Resetear la bandera cuando se cierra el modal
  useEffect(() => {
    console.log('🔄 useEffect RESET ejecutándose - isOpen:', isOpen);
    if (!isOpen) {
      setDataPreFilled(false);
    }
  }, [isOpen]);


  // ✅ 4. Pre-seleccionar cliente si hay match exacto
  useEffect(() => {
    console.log('🔄 useEffect CLIENTE ejecutándose - clientMatch:', !!clientMatch);
    if (clientMatch?.exact_match) {

      setSelectedClient({
        type: 'existing',
        clientId: clientMatch.exact_match.id,
      });
    }
  }, [clientMatch]);

  // ✅ 5. Pre-seleccionar vendedor si hay sugerencia
  useEffect(() => {
    console.log('🔄 useEffect VENDEDOR ejecutándose - sellerMatch:', !!sellerMatch);
    if (sellerMatch?.seller) {

      setSelectedSeller(sellerMatch.seller.id);
    }
  }, [sellerMatch]);
    // ✅ NUEVO: Memoizar extractedData para evitar re-renders
  const extractedDataForClient = React.useMemo(() => ({
    client_name: data?.client_info?.client_name || '',
    account_manager: data?.account_manager || data?.client_info?.account_manager || '',
    contact_name: data?.client_info?.contact_name || data?.contact_name || '',
    contact_email: data?.client_info?.contact_email || data?.contact_email || '',
    contact_phone: data?.client_info?.contact_phone || data?.contact_phone || '',
  }), [data]);

  const handleInputChange = (field, value) => {
    console.log('🖊️ ESCRIBIENDO:', field, '=', value);
    console.log('📊 formData ANTES:', formData[field]);
    setFormData((prev) => {
      const newData = { ...prev, [field]: value };
      console.log('📊 formData DESPUÉS:', newData[field]);
      return newData;
    });
  };


  const handleClientSelect = (selection) => {
    setSelectedClient(selection);
  };

  const handleSubmit = async () => {
    if (!selectedClient) {
      alert('Por favor selecciona un cliente');
      return;
    }

    if (!selectedSeller) {
      alert('Por favor selecciona un account manager ');
      return;
    }

    if (!formData.proposal_number || !formData.subtotal) {
      alert('Por favor completa los campos requeridos');
      return;
    }

    setLoading(true);

    try {
      const confirmData = {
        proposal_number: formData.proposal_number,
        quote_date: formData.quote_date,
        category: formData.category,
        service_type: formData.service_type,
        account_manager: formData.account_manager,
        contact_name: formData.contact_name,
        contact_email: formData.contact_email,
        subtotal: formData.subtotal,
        notes: formData.notes,
        client_id: selectedClient.type === 'existing' ? selectedClient.clientId : null,
        client_name: selectedClient.type === 'new' ? selectedClient.data.name : formData.client_name,
        seller_id: selectedSeller,
        items: data.items || {},
        pdf_file_path: data.temp_files?.pdf_path || '',
        xml_file_path: data.temp_files?.xml_path || '',
      };

      if (selectedClient.type === 'new') {
        Object.assign(confirmData, selectedClient.data);
      }

      await onConfirm(confirmData);
      toggle();
    } catch (error) {
      console.error('Error al confirmar propuesta:', error);
      alert(error.response?.data?.error || 'Error al crear propuesta');
    } finally {
      setLoading(false);
    }
  };

  if (!data) return null;

  const tax = parseFloat(formData.subtotal || 0) * 0.16;
  const total = parseFloat(formData.subtotal || 0) + tax;
  console.log('🎨 RENDER del modal - formData.contact_name:', formData.contact_name);

  return (
    <Modal 
      isOpen={isOpen} 
      toggle={toggle} 
      size="xl"
      backdrop="static"
      className="modal-dialog-centered"
      style={{ maxWidth: '95vw' }}
    >
      <ModalHeader 
        toggle={toggle}
        className="bg-gradient-primary border-0"
        style={{
          background: 'linear-gradient(135deg, #038D81 0%, #026B62 100%)',
        }}
      >
        <div style={{ position: 'relative', zIndex: 2 }}>
          <h5 className="mb-0 text-white font-weight-bold">
            <i className="ni ni-single-copy-04 me-2"></i>
            Confirmar Propuesta
          </h5>
          <small className="text-white opacity-8 d-block mt-1">
            Verifica los datos extraídos y visualiza el PDF simultáneamente
          </small>
        </div>
      </ModalHeader>
      
      <ModalBody className="p-0" style={{ height: '75vh', overflow: 'hidden' }}>
        <Row className="g-0 h-100">
          {/* ========== COLUMNA IZQUIERDA: FORMULARIO (50%) ========== */}
          <Col md="6" className="border-end" style={{ 
            overflowY: 'auto', 
            height: '100%',
            background: '#f8fafc'
          }}>
            <div className="p-4">
              {/* Alerta de versión */}
              {versionInfo?.exists && (
                <Alert color="warning" className="alert-dismissible fade show mb-3">
                  <span className="alert-icon"><i className="ni ni-bell-55"></i></span>
                  <span className="alert-text">
                    <strong>Atención:</strong> Esta propuesta ya existe (v{versionInfo.latest_version}).
                    {versionInfo.has_changes && (
                      <span> Se detectaron cambios en: {versionInfo.changes.join(', ')}</span>
                    )}
                  </span>
                </Alert>
              )}

              {/* 1️⃣ Información Básica */}
              <div className="card shadow border-0 mb-3">
                <div className="card-header bg-gradient-primary">
                  <h6 className="mb-0 text-white">
                    <i className="ni ni-single-copy-04 me-2"></i>
                    Información de la Propuesta
                  </h6>
                </div>
                <div className="card-body p-3">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Número de Propuesta <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-alternative"
                          value={formData.proposal_number}
                          onChange={(e) => handleInputChange('proposal_number', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Fecha
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-alternative"
                          value={formData.quote_date}
                          onChange={(e) => handleInputChange('quote_date', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2️⃣ Vendedor */}
              <div className="card shadow border-0 mb-3">
                <div className="card-header bg-gradient-primary">
                  <h6 className="mb-0 text-white">
                    <i className="ni ni-badge me-2"></i>
                    Account manager Asignado
                  </h6>
                </div>
                <div className="card-body p-3">
                  {sellerMatch?.seller && (
                    <Alert color="" className="mb-3">
                      <div className="d-flex align-items-start">
                        <span className="alert-icon"><i className="ni ni-check-bold"></i></span>
                        <div className="ms-2 flex-grow-1">
                          <strong className="d-block">Account manager  Sugerido</strong>
                          <span className="d-block mt-1">{sellerMatch.seller.full_name}</span>
                          {sellerMatch.seller.email && (
                            <small className="text-muted d-block">
                              <i className="ni ni-email-83 me-1"></i>
                              {sellerMatch.seller.email}
                            </small>
                          )}
                          <small className="text-muted d-block mt-2">
                            <i className="ni ni-bulb-61 me-1"></i>
                            Coincidencia con "{formData.account_manager}"
                          </small>
                        </div>
                      </div>
                    </Alert>
                  )}

                  <div className="form-group mb-0">
                    <label className="form-control-label text-uppercase text-xs font-weight-bold">
                      Confirmar o Cambiar Account manager <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control form-control-alternative"
                      value={selectedSeller || ''}
                      onChange={(e) => setSelectedSeller(e.target.value ? parseInt(e.target.value) : null)}
                    >
                      <option value="">Seleccionar Account manager...</option>
                      {availableSellers.map(seller => (
                        <option key={seller.id} value={seller.id}>
                          {seller.full_name} {seller.email && `(${seller.email})`}
                          {sellerMatch?.seller?.id === seller.id && ' ⭐ SUGERIDO'}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* 3️⃣ Cliente */}
              <div className="card shadow border-0 mb-3">
                <div className="card-header bg-gradient-primary">
                  <h6 className="mb-0 text-white">
                    <i className="ni ni-circle-08 me-2"></i>
                    Cliente
                  </h6>
                </div>
                <div className="card-body p-3">
                  {clientMatch?.exact_match ? (
                    <Alert color="success" className="mb-3">
                      <span className="alert-icon"><i className="ni ni-check-bold"></i></span>
                      <span className="alert-text">
                        <strong>Cliente encontrado:</strong> {clientMatch.exact_match.name}
                      </span>
                    </Alert>
                  ) : (
                    <ClientMatchSelector
                      similarClients={clientMatch?.similar_clients || []}
                      extractedData={extractedDataForClient}
                      selectedClient={selectedClient}
                      onSelect={handleClientSelect}
                    />
                  )}


                  <div className="row mt-3">
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Nombre del Cliente
                          {!clientMatch?.exact_match && <span className="text-danger ms-1">*</span>}
                        </label>
                        <input
                          type="text"
                          className={`form-control form-control-alternative ${
                            clientMatch?.exact_match ? 'bg-secondary' : ''
                          }`}
                          value={formData.client_name}
                          onChange={(e) => handleInputChange('client_name', e.target.value)}
                          readOnly={!!clientMatch?.exact_match}
                          placeholder="Ej: Galika"
                        />
                        {!clientMatch?.exact_match && (
                          <small className="form-text text-muted">
                            <i className="ni ni-pencil me-1"></i>
                            Puedes editar este campo si es necesario
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Razón Social
                        </label>
                        <input
                          type="text"
                          className={`form-control form-control-alternative ${
                            clientMatch?.exact_match ? 'bg-secondary' : ''
                          }`}
                          value={formData.client_razon_social}
                          onChange={(e) => handleInputChange('client_razon_social', e.target.value)}
                          readOnly={!!clientMatch?.exact_match}
                          placeholder="Ej: bmw sa de cv "
                        />
                        {!formData.client_razon_social && !clientMatch?.exact_match && (
                          <small className="form-text text-warning">
                            <i className="ni ni-bell-55 me-1"></i>
                            Este campo está vacío en el PDF
                          </small>
                        )}
                        {!clientMatch?.exact_match && formData.client_razon_social && (
                          <small className="form-text text-muted">
                            <i className="ni ni-pencil me-1"></i>
                            Puedes editar este campo si es necesario
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              {/* 4️⃣ Contacto */}
              <div className="card shadow border-0 mb-3">
                <div className="card-header bg-gradient-primary">
                  <h6 className="mb-0 text-white">
                    <i className="ni ni-email-83 me-2"></i>
                    Información de Contacto
                  </h6>
                </div>
                <div className="card-body p-3">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Nombre del Contacto
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-alternative"
                          value={formData.contact_name}
                          onChange={(e) => handleInputChange('contact_name', e.target.value)}
                          placeholder="Ej: Juan Pérez"
                        />
                        <small className="form-text text-muted">
                          <i className="ni ni-pencil me-1"></i>
                          Campo editable
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Correo del Contacto
                        </label>
                        <input
                          type="email"
                          className="form-control form-control-alternative"
                          value={formData.contact_email}
                          onChange={(e) => handleInputChange('contact_email', e.target.value)}
                          placeholder="contacto@empresa.com"
                        />
                        <small className="form-text text-muted">
                          <i className="ni ni-pencil me-1"></i>
                          Campo editable
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Teléfono del Contacto
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-alternative"
                          value={formData.contact_phone}
                          onChange={(e) => handleInputChange('contact_phone', e.target.value)}
                          placeholder="4441234567"
                        />
                        <small className="form-text text-muted">
                          <i className="ni ni-pencil me-1"></i>
                          Campo editable
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          RFC
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-alternative"
                          value={formData.rfc || ''}
                          onChange={(e) => handleInputChange('rfc', e.target.value.toUpperCase())}
                          placeholder="ABC123456XYZ"
                          maxLength="13"
                        />
                        <small className="form-text text-muted">
                          <i className="ni ni-pencil me-1"></i>
                          Campo editable (opcional)
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group mb-0">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Dirección Completa
                        </label>
                        <textarea
                          className="form-control form-control-alternative"
                          rows="2"
                          value={formData.direccion || ''}
                          onChange={(e) => handleInputChange('direccion', e.target.value)}
                          placeholder="Calle, número, colonia, ciudad, estado, CP"
                        ></textarea>
                        <small className="form-text text-muted">
                          <i className="ni ni-pencil me-1"></i>
                          Campo editable (opcional)
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              {/* 5️⃣ Detalles del Servicio */}
              <div className="card shadow border-0 mb-3">
                <div className="card-header bg-gradient-primary">
                  <h6 className="mb-0 text-white">
                    <i className="ni ni-briefcase-24 me-2"></i>
                    Detalles del Servicio
                  </h6>
                </div>
                <div className="card-body p-3">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Categoría
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-alternative"
                          value={formData.category}
                          onChange={(e) => handleInputChange('category', e.target.value)}
                          placeholder="Ej: Coaching"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Tipo de Servicio
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-alternative"
                          value={formData.service_type}
                          onChange={(e) => handleInputChange('service_type', e.target.value)}
                          placeholder="Ej: Coaching Ejecutivo"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Personas
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-alternative"
                          value={formData.num_personas}
                          onChange={(e) => handleInputChange('num_personas', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Grupos
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-alternative"
                          value={formData.num_grupos}
                          onChange={(e) => handleInputChange('num_grupos', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Horas
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-alternative"
                          value={formData.horas_totales}
                          onChange={(e) => handleInputChange('horas_totales', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Sesiones
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-alternative"
                          value={formData.num_sesiones}
                          onChange={(e) => handleInputChange('num_sesiones', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Nivel Administrativo
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-alternative"
                          value={formData.nivel}
                          onChange={(e) => handleInputChange('nivel', e.target.value)}
                          placeholder="Ej: Gerencial"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Idioma
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-alternative"
                          value={formData.idioma}
                          onChange={(e) => handleInputChange('idioma', e.target.value)}
                          placeholder="Ej: Español"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Ubicación
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-alternative"
                          value={formData.ubicacion}
                          onChange={(e) => handleInputChange('ubicacion', e.target.value)}
                          placeholder="Ej: CDMX"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-control-label text-uppercase text-xs font-weight-bold">
                      Material (¿cuál?)
                    </label>
                    <textarea
                      className="form-control form-control-alternative"
                      rows="2"
                      value={formData.material_type}
                      onChange={(e) => handleInputChange('material_type', e.target.value)}
                      placeholder="Ej: Prueba DISC, Material digital"
                    ></textarea>
                  </div>
                  <div className="form-group mb-3">
                    <label className="form-control-label text-uppercase text-xs font-weight-bold">
                     Material Cobrado 
                    </label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">$</span>
                      </div>
                      <input
                        type="number"
                        className="form-control form-control-alternative"
                        value={formData.material_cobrado}
                        onChange={(e) => handleInputChange('material_cobrado', e.target.value)}
                        step="0.01"
                        placeholder="Lo que se le cobra al cliente"
                      />
                    </div>
                    <small className="form-text text-muted">
                      <i className="ni ni-money-coins me-1"></i>
                       Monto que aparece en la propuesta para el cliente
                    </small>
                   </div>


                  <div className="form-group mb-0">
                    <label className="form-control-label text-uppercase text-xs font-weight-bold">
                      Precio por Hora
                    </label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">$</span>
                      </div>
                      <input
                        type="number"
                        className="form-control form-control-alternative"
                        value={formData.precio_hora}
                        onChange={(e) => handleInputChange('precio_hora', e.target.value)}
                        step="0.01"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* 6️⃣ Logística */}
              <div className="card shadow border-0 mb-3">
                <div className="card-header bg-gradient-primary">
                  <h6 className="mb-0 text-white">
                    <i className="ni ni-delivery-fast me-2"></i>
                    Logística
                  </h6>
                </div>
                <div className="card-body p-3">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Viáticos
                        </label>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="viaticos"
                            checked={formData.viaticos}
                            onChange={(e) => handleInputChange('viaticos', e.target.checked)}
                          />
                          <label className="custom-control-label" htmlFor="viaticos">
                            Incluye viáticos
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Costo de Viáticos
                        </label>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">$</span>
                          </div>
                          <input
                            type="number"
                            className="form-control form-control-alternative"
                            value={formData.costo_viaticos}
                            onChange={(e) => handleInputChange('costo_viaticos', e.target.value)}
                            step="0.01"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mb-0">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Lugar
                        </label>
                        <select
                          className="form-control form-control-alternative"
                          value={formData.lugar}
                          onChange={(e) => handleInputChange('lugar', e.target.value)}
                        >
                          <option value="">Seleccionar...</option>
                          <option value="SI">Sí</option>
                          <option value="NO">No</option>
                          <option value="VIRTUAL">Virtual</option>
                        </select>
                                              </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-0">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Costo del Lugar
                        </label>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">$</span>
                          </div>
                          <input
                            type="number"
                            className="form-control form-control-alternative"
                            value={formData.costo_lugar}
                            onChange={(e) => handleInputChange('costo_lugar', e.target.value)}
                            step="0.01"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 7️⃣ Costos Adicionales */}
              <div className="card shadow border-0 mb-3">
                <div className="card-header bg-gradient-primary">
                  <h6 className="mb-0 text-white">
                    <i className="ni ni-money-coins me-2"></i>
                    Costos Adicionales
                  </h6>
                </div>
                <div className="card-body p-3">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Costo de Material
                        </label>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">$</span>
                          </div>
                          <input
                            type="number"
                            className="form-control form-control-alternative"
                            value={formData.material_didactico}
                            onChange={(e) => handleInputChange('material_didactico', e.target.value)}
                            step="0.01"
                          />
                        </div>
                        <small className="form-text text-muted">
                          <i className="ni ni-box-2 me-1"></i>
                          Lo que cuesta el material a MAS+
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold">
                          Otros Costos
                        </label>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">$</span>
                          </div>
                          <input
                            type="number"
                            className="form-control form-control-alternative"
                            value={formData.otros_costos}
                            onChange={(e) => handleInputChange('otros_costos', e.target.value)}
                            step="0.01"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              {/* 8️⃣ Términos de Pago y Totales */}
              <div className="card shadow border-0 mb-3">
                <div className="card-header bg-gradient-primary">
                  <h6 className="mb-0 text-white">
                    <i className="ni ni-credit-card me-2"></i>
                    Términos de Pago y Montos
                  </h6>
                </div>
                <div className="card-body p-3">
                  <div className="form-group mb-3">
                    <label className="form-control-label text-uppercase text-xs font-weight-bold">
                      Condiciones de Pago
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-alternative"
                      value={formData.terminos_pago}
                      onChange={(e) => handleInputChange('terminos_pago', e.target.value)}
                      placeholder="Ej: 50% anticipo, 50% contra entrega"
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-control-label text-uppercase text-xs font-weight-bold">
                      Subtotal <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">$</span>
                      </div>
                      <input
                        type="number"
                        className="form-control form-control-alternative"
                        value={formData.subtotal}
                        onChange={(e) => handleInputChange('subtotal', e.target.value)}
                        step="0.01"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <div className="form-group mb-0">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold text-muted">
                          IVA (16%)
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-alternative bg-secondary"
                          value={`$${tax.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mb-0">
                        <label className="form-control-label text-uppercase text-xs font-weight-bold text-muted">
                          Total
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-alternative font-weight-bold bg-secondary"
                          value={`$${total.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 9️⃣ Notas */}
              <div className="card shadow border-0 mb-3">
                <div className="card-header bg-gradient-primary">
                  <h6 className="mb-0 text-white">
                    <i className="ni ni-align-left-2 me-2"></i>
                    Notas Adicionales
                  </h6>
                </div>
                <div className="card-body p-3">
                  <div className="form-group mb-0">
                    <label className="form-control-label text-uppercase text-xs font-weight-bold">
                      Observaciones
                    </label>
                    <textarea
                      className="form-control form-control-alternative"
                      rows="3"
                      value={formData.notes}
                      onChange={(e) => handleInputChange('notes', e.target.value)}
                      placeholder="Notas opcionales sobre esta propuesta..."
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          {/* ========== COLUMNA DERECHA: PDF VIEWER (50%) ========== */}
          <Col md="6" className="bg-white" style={{ 
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}>
            {/* Header del PDF */}
            <div 
              className="p-3 border-bottom"
              style={{
                background: 'linear-gradient(to right, #f8fafc, #e8f5f4)',
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-0 font-weight-bold text-dark">
                    <i className="ni ni-single-copy-04 me-2 text-primary"></i>
                    Vista Previa del PDF
                  </h6>
                  <small className="text-muted">
                    {formData.proposal_number || 'Sin número'} 
                    {data?.pdf_metadata?.last_page && (
                      <span className="ms-2">
                        <Badge color="info" className="badge-sm">
                          Página {data.pdf_metadata.last_page} de {data.pdf_metadata.total_pages}
                        </Badge>
                      </span>
                    )}
                  </small>
                </div>
                <div className="d-flex gap-2">
                  <Button
                    color="primary"
                    size="sm"
                    className="btn-icon"
                    onClick={() => window.open(pdfUrl?.split('#')[0], '_blank')}
                    disabled={!pdfUrl}
                    title="Ver PDF completo"
                  >
                    <span className="btn-inner--icon">
                      <i className="ni ni-laptop"></i>
                    </span>
                  </Button>
                </div>
              </div>
            </div>

            {/* Contenedor del PDF */}
            <div 
              className="flex-grow-1 position-relative"
              style={{ 
                background: '#f1f5f9',
                overflow: 'hidden'
              }}
            >
              {pdfUrl ? (
                <iframe
                  src={pdfUrl}
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                  }}
                  title="Vista Previa Propuesta"
                />
              ) : (
                <div className="d-flex flex-column align-items-center justify-content-center h-100">
                  <div 
                    className="icon icon-shape bg-gradient-primary shadow-primary text-center rounded-circle mb-3"
                    style={{ width: '80px', height: '80px' }}
                  >
                    <i className="ni ni-folder-17 text-white" style={{ fontSize: '2rem', lineHeight: '80px' }}></i>
                  </div>
                  <h5 className="text-dark">PDF no disponible</h5>
                  <p className="text-sm text-muted">
                    El documento no se pudo cargar
                  </p>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </ModalBody>

      {/* ✅ FOOTER */}
      <ModalFooter className="border-0 bg-light">
        <button 
          className="btn btn-secondary" 
          onClick={toggle} 
          disabled={loading}
        >
          <i className="ni ni-fat-remove me-2"></i>
          Cancelar
        </button>
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={loading || !selectedClient || !selectedSeller}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
              Guardando...
            </>
          ) : (
            <>
              <i className="ni ni-check-bold me-2"></i>
              Confirmar y Guardar
            </>
          )}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default QuoteConfirmModal;

